export default {
  initMobileNavigationScrollLockEventListener: () => {
    const navToggle = document.getElementById('nav-menu');

    if (navToggle?.checked) {
      document.body.classList.add('no-scroll');
    }

    navToggle.addEventListener('change', event => {
      if (event.currentTarget?.checked) {
        document.body.classList.add('no-scroll');
      } else {
        document.body.classList.remove('no-scroll');
      }
    });
  }
};
